import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-eleven-plus-cw',
    templateUrl: './eleven-plus-cw.component.html',
    styleUrls: ['./eleven-plus-cw.component.css'],
    standalone: false
})
export class ElevenPlusCwComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
